/**
 *
 * Moves a video.js button after another button for easier position management
 * without absolute CSS positions.
 *
 * @param player          The video.js player instance
 * @param sourceName      Name of the video.js button that needs to be moved
 * @param afterName       Name of the video.js button that sourceName needs to be moved after
 * @param intervalTime    Interval time to check if the elements are available (default = 10)
 * @param currentRetry    Current retry (default = 0)
 * @param maxRetries      Max number of timeout retries (default = 100)
 */
const moveButtonAfter = (options) => {
  const {
    player,
    sourceName,
    afterName,
    intervalTime = 10,
    currentRetry = 0,
    maxRetries = 100,
  } = options;

  /* eslint-disable no-underscore-dangle */
  const sourceButton = player.controlBar
    .children()
    .find((el) => el.name_ === sourceName);
  const destinationButton = player.controlBar
    .children()
    .find((el) => el.name_ === afterName);
  /* eslint-enable no-underscore-dangle */

  if (sourceButton && destinationButton) {
    const sourceButtonElement = sourceButton.el();
    const destinationButtonElement = destinationButton.el();

    sourceButtonElement.parentNode.insertBefore(
      sourceButtonElement,
      destinationButtonElement.nextSibling
    );

    return;
  }

  if (maxRetries > currentRetry) {
    setTimeout(
      () =>
        moveButtonAfter({
          ...options,
          currentRetry: currentRetry + 1,
        }),
      intervalTime
    );
  }
};

export default moveButtonAfter;
